export const localization = {
  pt: {
    header: 'Detalhamento das métricas',
    locale: 'pt-BR',
    title: 'Visão detalhada do plano',
    compiledInformation: {
      plan: 'Detalhamento dos tokens',
      disclaimer:
        '*O fechamento de um mês estará disponível em até 5 dias úteis contados do último dia desse mesmo mês.',
      totalTokensLabel: 'Total de tokens utilizados',
    },
    dailyConsumption: {
      title: 'Consumo diário',
      description: 'Acompanhe o consumo do seu plano dia a dia',
      columnDate: 'Data',
      columnTotalTokens: 'Total de tokens',
    },
    botConsumption: {
      title: 'Consumo por fluxo ou roteador',
      description: 'Acompanhe o consumo de seus tokens por fluxo ou roteador',
      columnName: 'Fluxo/Roteador',
      columnTotalTokens: 'Total de tokens',
    },
  },

  en: {
    header: 'Metrics Breakdown',
    locale: 'en-US',
    title: 'Detailed plan view',
    compiledInformation: {
      plan: 'Detailed plan view',
      disclaimer:
        '*The closing invoice of a month will be available within 5 business days from the last day of that month.',
      totalTokensLabel: 'Total tokens used',
    },
    dailyConsumption: {
      title: 'Daily consumption',
      description: 'Track your plan consumption day by day',
      columnDate: 'Date',
      columnTotalTokens: 'Total tokens',
    },
    botConsumption: {
      title: 'Consumption by flow or router',
      description: 'Track your token consumption by flow or router',
      columnName: 'Flow/Router',
      columnTotalTokens: 'Total tokens',
    },
  },

  es: {
    header: 'Detalle de las Métricas',
    locale: 'es-ES',
    title: 'Vista detallada del plan',
    compiledInformation: {
      plan: 'Vista detallada del plan',
      disclaimer:
        '*El cierre de un mes estará disponible dentro de los 5 días hábiles a partir del último día de ese mes.',
      totalTokensLabel: 'Total de tokens utilizados',
    },
    dailyConsumption: {
      title: 'Consumo diario',
      description: 'Realiza un seguimiento del consumo de tu plan día a día',
      columnDate: 'Fecha',
      columnTotalTokens: 'Total de tokens',
    },
    botConsumption: {
      title: 'Consumo por flujo o enrutador',
      description: 'Realiza un seguimiento del consumo de tokens por flujo o enrutador',
      columnName: 'Flujo/Enrutador',
      columnTotalTokens: 'Total de tokens',
    },
  },
};
